import SectionWrapper from "../../SectionWrapper"
import GradientWrapper from "../../GradientWrapper"
import user1 from "../../../assets/testimonial/user1.webp"
import user2 from "../../../assets/testimonial/user2.webp"
import user3 from "../../../assets/testimonial/user3.webp"
import user4 from "../../../assets/testimonial/user4.webp"
import user5 from "../../../assets/testimonial/user5.webp"
import user6 from "../../../assets/testimonial/user6.webp"
import LayoutEffect from "../../LayoutEffect"

const Index = () => {

    const testimonials = [
        {
            avatar: user1,
            name: "General Walter",
            title: "Happy General",
            quote: "Barrenpay: Your trusted companion for secure online payments. Virtual Visa cards provide privacy, convenience, and protection. Simplify your financial life with Barrenpay's reliable service."
        },
        {
            avatar: user2,
            name: "Nyasha Hove",
            title: "Founder of HoveTech",
            quote: "Take control of your finances with Barrenpay's virtual Visa cards. Set spending limits, easily cancel subscriptions, and enjoy peace of mind in your online transactions"
        },
        {
            avatar: user3,
            name: "Sidi jeddou",
            title: "Founder of Float UI",
            quote: "With Barrenpay, travel the world without worries. Virtual Visa cards ensure safe and convenient payments, whether you're exploring new destinations or making international purchases."
        },
        {
            avatar: user4,
            name: "Ghazbel",
            title: "Founder of forceY",
            quote: "Barrenpay's virtual Visa cards offer security and flexibility. Safeguard your finances, shop with confidence, and manage subscriptions effortlessly. A must-have for online enthusiasts."
        },
        {
            avatar: user5,
            name: "Ana khan",
            title: "Founder of larax",
            quote: "Convenient virtual Visa cards by Barrenpay make online shopping a breeze. Control spending, protect personal information, and enjoy seamless transactions. Trustworthy and user-friendly"
        },
        {
            avatar: user6,
            name: "Ahmed khasem",
            title: "Founder of Let’s code",
            quote: "Barrenpay: Secure virtual Visa cards for worry-free online transactions. Simple setup, reliable service, and enhanced privacy. Highly recommended for peace of mind."
        },
    ]

    return (
        <SectionWrapper>
            <div id="testimonials" className="custom-screen text-gray-300">
                <div className="max-w-2xl text-center md:mx-auto">
                    <h2 className="text-gray-50 text-3xl font-semibold sm:text-4xl">
                        Barrenpay Visa cards are loved by lots of consumers around the world
                    </h2>
                    <p className="mt-3">
                    Experience the Difference: Barrenpay Virtual Visa Cards Earn High Praise from Users. Satisfied Customers Speak Out: Barrenpay's Virtual Visa Cards Simplify Online Payments
                </p>
                </div>
                <GradientWrapper wrapperClassName="max-w-sm h-40 top-12 inset-x-0" className="mt-12">
                    <LayoutEffect
                        className="duration-1000 delay-300"
                        isInviewState={{
                            trueState: "opacity-1",
                            falseState: "opacity-0 translate-y-12"
                        }}
                    >
                        <ul className="grid gap-6 duration-1000 delay-300 ease-in-out sm:grid-cols-2 lg:grid-cols-3">
                            {
                                testimonials.map((item, idx) => (
                                    <li key={idx} className="p-4 rounded-xl border border-gray-800"
                                        style={{
                                            backgroundImage: "radial-gradient(100% 100% at 50% 50%, rgba(124, 58, 237, 0.05) 0%, rgba(124, 58, 237, 0) 100%)"
                                        }}
                                    >
                                        <figure className="flex flex-col justify-between gap-y-6 h-full">
                                            <blockquote className="">
                                                <p className="">
                                                    {item.quote}
                                                </p>
                                            </blockquote>
                                            <div className="flex items-center gap-x-4">
                                                <image
                                                    src={item.avatar}
                                                    alt={item.name}
                                                    className="w-14 h-14 rounded-full object-cover"
                                                />
                                                <div>
                                                    <span className="block text-gray-50 font-semibold">{item.name}</span>
                                                    <span className="block text-sm mt-0.5">{item.title}</span>
                                                </div>
                                            </div>
                                        </figure>
                                    </li>
                                ))
                            }
                        </ul>
                    </LayoutEffect>
                </GradientWrapper>
            </div>
        </SectionWrapper>
    )
}

export default Index